import { render, staticRenderFns } from "./Checkpoints.vue?vue&type=template&id=147c717c&scoped=true"
import script from "./Checkpoints.vue?vue&type=script&lang=js"
export * from "./Checkpoints.vue?vue&type=script&lang=js"
import style0 from "./Checkpoints.vue?vue&type=style&index=0&id=147c717c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c717c",
  null
  
)

export default component.exports